export default "__VITE_PUBLIC_ASSET__108436aa__"